// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23EnC","toggle":"styles_toggle__2uFq1","preview":"styles_preview__wTj_O"};